import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material'; 
import { ReservationService } from 'src/app/services/reservation.service';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { CancelledReservationReasonFilter } from '../../../model/cancelled-reservation-reason-filter';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Reservation } from 'src/app/model/reservation';

@Component({
  selector: 'app-medical-appointment-wizard-cancel-dialog',
  templateUrl: 'medical-appointment-wizard-cancel-dialog.component.html'
})
export class MedicalAppointmentWizardCancelDialogComponent implements OnInit {

  form: FormGroup;
  loading: boolean;
  cancelledReservationReasons: CancelledReservationReasonFilter[] = [];

  constructor(
    public dialogRef: MatDialogRef<MedicalAppointmentWizardCancelDialogComponent>,
    private reservationService: ReservationService,
    private notificationToastService: NotificationToastService,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: Reservation) {
      this.form = this.formBuilder.group({
        Observations: [''],
        CancelledReservationReason: [null, Validators.required]
      });
  }

  get f() { return this.form.controls; }

  async ngOnInit() {
     try {
      this.loading = true;
      this.cancelledReservationReasons =
         await this.reservationService.getCancelledReservationReasonFilters();
     } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Cancelación de asignación');
     } finally {
      this.loading = false;
     }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async save() {
    try {
      if (!this.form.invalid) {
        if (await this.reservationService.medicalAppointmentCancelledReservation(
          this.form.value.CancelledReservationReason.Id, this.form.value.Observations,
          this.data)) {
          this.dialogRef.close(true);
        }
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Cancelación de turno');
    }
  }
}
